module.exports = __webpack_public_path__ + "img/video-in-home-blue.4bb83290.svg";